import React, { useEffect, useState } from 'react'
import ListLayout from '../../../../component/listLayout'
import AddButton from '../../../../component/AddButton'
import InputSearch from '../../../../component/InputSearch'
import { Link, useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Box, Button, Checkbox, FormControl, FormControlLabel, MenuItem, Select } from '@mui/material'
import dayjs from 'dayjs'
import Swal from 'sweetalert2'
import { getCatalogs, getReservesSeedAllBranchList, getReservesSeedList, updateReserve } from '../../services/api'

export default function ReserveList() {
    const [searchParams, setSearchParams] = useSearchParams()
    let q = searchParams.get('q') || ''
    let c = searchParams.get('c') || ''
    let checked = searchParams.get('checked') || ''
    let page = searchParams.get('page') || '1'
    let id = searchParams.get('id') || ''
    const [catalog, setCatalog] = useState([])
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false);
    const [rowsPerPage] = useState(10);
    const { profile } = useSelector(state => state.profile)
    function checkReserveCenter(reserve) {
        const ReserveNoCenter = reserve?.ReserveNo.split('-');
        return ReserveNoCenter.length > 1 ? true : false
    }
   
 
    const getList = async () => {
        setLoading(true)
        const data = await getReservesSeedList(q, c, page, rowsPerPage)
        setData(data)
        setLoading(false)
    }
    const getCatalogList = async () => {
        const data = await getCatalogs()
        setCatalog(data)
    }
    const getAllBranchList = async () => {
        setLoading(true)
        const data = await getReservesSeedAllBranchList(q, c, page, rowsPerPage)
        setData(data)
        setLoading(false)
    }
    async function Close(ReserveNo, RefNo) {
        Swal.fire({
            title: `ยืนยันการยกเลิก: ${RefNo}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#4ab866',
            cancelButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                const body = {
                    ReserveNo: ReserveNo,
                    Status: 'C'
                }
                const post = async () => {
                    const res = await updateReserve(body)
                    if (res.status === true) {
                        Swal.fire(
                            'เรียบร้อย',
                            '',
                            'success'
                        )
                        if (checked === 'true') {
                            getAllBranchList()
                        } else {
                            getList()
                        }
                      }
                }
                post()
            }
        })

    }
    useEffect(() => {
        getCatalogList()
    }, [])
    useEffect(() => {
        if (checked === 'true') {
            getAllBranchList()
        } else {
            getList()
        }
    }, [q, c, checked, page, rowsPerPage])
    
    const head = [
        '',
        'ที่',
        'ศูนย์เมล็ดพันธุ์ข้าว',
        'ผู้สำรอง',
        'เลขที่หนังสือ',
        'ลงวันที่',
        'จังหวัด',
        'อำเภอ',
        'ชื่อโครงการ',
        'ปริมาณ (กิโลกรัม)',
        'สถานะ',
        'ขาย',
        'ดำเนินการ',
    ]
    const body = data?.items?.map((x, i) => {

        return {
            id: x?.ReserveNo,
            item1: x?.SaleStatus === 'N' && (profile?.BranchNo?.BranchNo === x?.BranchNo?.BranchNo) ? <span>NEW!</span> : '',
            item2: (data?.meta?.currentPage - 1) * data?.meta?.itemsPerPage + 1 + i,
            item3: x?.BranchNo?.BranchName,
            item4: x?.CustomerNo?.ContactName,
            item5: x?.RefNo,
            item6: dayjs(x?.DocumentDate).format('DD/MM/BBBB'),
            item7: x?.Province,
            item8: x?.District,
            item9: x?.CampaignName,
            item10: x?.TotalQty?.toLocaleString(),
            item11: x?.Status === 'Y' ?
                <span class="status-active">
                    ปกติ
                </span> : x?.Status === 'N' ?
                    <span class="status-inactive">
                        ยกเลิก
                    </span> : x?.Status === 'D' ?
                        <span class="status-active">
                            เสร็จสิ้น
                        </span> : x?.Status === 'C' ?
                            <span class="status-draft">
                                ปิด
                            </span> : '',
            item12: x.SaleStatus === 'P' &&
                <span class="status-inactive">
                    ขายไปบางส่วน
                </span>,
            item13: <>
                <Link to={`/stock/reserve/${x?.ReserveNo}`}>
                    <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }} onClick={() => setSearchParams({ id: x?.ReserveNo, page: page, q: q, c: c, checked: checked, })}>เรียกดู</Button>
                </Link>
                {
                    (x?.Status === 'Y') && (profile?.BranchNo?.BranchNo === x?.BranchNo?.BranchNo) && !checkReserveCenter(x) &&
                    <Button onClick={() => Close(x?.ReserveNo, x?.RefNo)} variant='contained' color='error' sx={{ marginLeft: '10px' }}>ปิด</Button>

                }
                {
                    (x?.Status === 'Y') && (profile?.BranchNo?.BranchNo === '00') && checkReserveCenter(x) &&
                    <Button onClick={() => Close(x?.ReserveNo, x?.RefNo)} variant='contained' color='error' sx={{ marginLeft: '10px' }}>ปิด</Button>

                }</>
            ,
        }
    })
    return (
        <ListLayout title={'รายการสำรองเมล็ดพันธุ์'} action={<>
            {profile?.BranchNo?.BranchNo !== '00' && <>
                <div class="col-lg-3 col-md-6 d-flex align-items-center">
                    <FormControlLabel control={<Checkbox checked={checked === 'true' ? true : false} onChange={e => setSearchParams({ q: q, c: c, checked: `${e.target.checked}` })} />} label="แสดงรายการของศูนย์เมล็ดพันธุ์ทั้งหมด" />
                </div>
                <AddButton link={'/stock/reserve/add'} />

            </>}
            <div class="col-lg-2 col-md-6">
                <Box className='backgroundField' sx={{ marginRight: '20px' }}>
                    <FormControl variant="standard" fullWidth >
                        <Select value={c || 'all'} onChange={e => setSearchParams({ q: q, c: e.target.value, checked: checked })}
                            disableUnderline
                            MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                        >
                            <MenuItem value='all'>ทุกพันธุ์ข้าว</MenuItem>
                            {catalog?.map((x) => <MenuItem value={x?.CatalogNo}>{x?.CatalogName}</MenuItem>)}
                        </Select>
                    </FormControl>
                </Box>
            </div>

            <InputSearch value={q} onChange={e => setSearchParams({ q: e.target.value,c: c, checked: checked })} placeholder={"ค้นหา เลขที่เอกสาร"} />
        </>} loading={loading} head={head} body={body} pagination={{
            count: data?.meta?.totalPages,
            page: +page,
            event: { q: q,c: c, checked: checked, id: id }
        }} id={id} setSearchParams={setSearchParams} />
    )
}
